




import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import { InvoicePersonType } from '@/modules/invoice/models/invoice-reource.model'

@Component
export default class InvoicePersonTypeView extends Vue {
  @Prop({ required: true }) type!: InvoicePersonType
  @Prop({ required: true }) types!: { [key in InvoicePersonType]: string }
  @Prop({ default: false }) dark: boolean

  get typeColor() {
    switch (this.type) {
      case InvoicePersonType.LEGAL:
        return 'text-green'
      case InvoicePersonType.NATURAL:
        return this.dark ? 'text-yellow' : 'text-amber-7'
      default:
        return ''
    }
  }
}
